import posthog from 'posthog-js'
import { memo } from 'react'
import { ErrorIcon } from '../Icons/Error'
import styles from './Error.module.css'

interface ErrorDisplayProps {
  error: Error | null
}

export const logError = (component: string, message: string, error: Error) => {
  posthog.captureException(error)
  console.error(`${component}: ${message}`, {
    message: error?.message,
    stack: error?.stack,
    name: error?.name
  })
}

export const ErrorDisplay = memo(
  ({ error }: ErrorDisplayProps) => {
    console.error('ErrorDisplay', 'Rendering error:', {
      message: error?.message,
      stack: error?.stack,
      name: error?.name
    })
    posthog.captureException(error)
    return (
      <div className={styles.container} data-testid="error-container">
        <div className={styles.content}>
          <ErrorIcon styles={styles.icon} />
          <div className={styles.textContainer}>
            <div className={styles.text} data-testid="error-message">
              Something went wrong
            </div>
            <div className={styles.message} data-testid="error-message-details">
              {error?.message}
            </div>
            <div className={styles.line} />
            <button
              className={styles.goBackContainer}
              type="button"
              onClick={() => window.history.back()}
              aria-label="Go back"
            >
              <svg
                className={styles.goBackIcon}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              <span className={styles.goBackText}>Go Back</span>
            </button>
          </div>
        </div>
      </div>
    )
  },
  // Custom comparison function to only re-render when error message changes
  (prevProps, nextProps) => {
    return prevProps.error?.message === nextProps.error?.message
  }
)
